export class SessionStateKeys {
  static AccessToken = 'zoe-accessToken';
  static RefreshToken = 'zoe-refreshToken';
  static User = 'zoe-user';
}
